import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Buttons/Button';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import ButtonBar from '../../components/Fields/ButtonBar';
import Form from '../../components/Fields/Form';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import { useLocalStorage } from '../../components/Hooks/LocalStorageHook/useLocalStorage';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import BrandModel from '../../models/BrandModel';
import SearchCriteria from '../../models/common/SearchCriteria';
import DataService from "../../services/data.service";

const Brands: React.FC = () => {
    const [data, setData] = useState<BrandModel[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate();

    const [formData, setFormData] = useLocalStorage<SearchCriteria>("brandsFilter", { quickSearch: '' })

    useEffect(() => {
        getTableData(formData);
    }, []);

    function search(){
        if (formData.quickSearch.length >= 3)
            getTableData(formData)
    }

    function setDefaultCriteria() {
        setFormData({ quickSearch: '' })
        getTableData({ quickSearch: '' })
    }

    function getTableData(criteria) {
        localStorage.setItem('brandsFilter', JSON.stringify(criteria));
        DataService.post<BrandModel[]>('api/v1/brands/search', criteria)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/itemsetup/brand/add', { state: { title: 'New brand', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/brands/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData(formData);
            })
            .catch(e => { handleException(e); });
    }

    const formConfig: FormConfig = {
        fields: [{ name: 'quickSearch', label: 'Search' }],
        handleFieldChanged: search,
        handleSubmit: () => getTableData(formData),
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData);

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { dataProp: 'thumbnailUrl', dataType: 'image' },
        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Abbr.', dataProp: 'abbreviation', filterInfo: { filterType: 'Textbox' } },
        { title: 'Level', dataProp: 'treeLevel', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Tree', dataProp: 'nameTree', filterInfo: { filterType: 'Textbox' } },
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditBrand)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Form title='Brands' footer={(
                    <ButtonBar offset={2}>
                        <Button text='Search' {...getSubmitButtonProps()} />
                        <Button text='Clear' type='button' onClick={setDefaultCriteria} />
                    </ButtonBar>
                )}>
                    <Container fluid>
                        <TextboxField {...getFieldProps('quickSearch')} />
                    </Container>
                </Form>
                <div className="card" style={{ margin: '0 12px', padding: 12 }}>
                    <DataTable
                        name='dtBrands'
                        tableData={data}
                        colInfos={colInfos}
                        navigateTitle='Brand'
                        navigateUrl='/plm/itemsetup/brand/'
                    />
                </div>
            </div>
        </>
    );
}
export default Brands;